const React = require('react');
const { Background } = require('@andes-landings/background');
const { Title } = require('@andes-landings/title');
const Point = require('./point');
const ComponentText = require('./componentText');
const PointMobile = require('./pointMobile');
const { isYellowBlueLightBrand } = require('../../../../../utils/isYellowBlueLightBrand');

const InpersonPayment = ({ i18n, isMobile, lang, siteId, brand }) => {
  const isMLM = siteId === 'MLM';
  const descriptionLector = isMLM ? i18n.gettext('Usa dispositivos Point para pagos con tarjetas.') : i18n.gettext('Usa dispositivos Point para pagos con tarjetas y QR.');

  const bulletsAux = [
    { pillText: i18n.gettext('MERCADO PAGO POINT'), title: i18n.gettext('Lectores de tarjetas'), bullets: [descriptionLector, i18n.gettext('Conéctalos a celulares iOS o Android y tus puntos de venta.')], link: `/developers/${lang}/docs/mp-point/landing`, track: 'point', sites: ['MLA', 'MLB', 'MLM'], label: i18n.gettext('Mercado Pago Point') },
    { pillText: i18n.gettext('CÓDIGO QR'), title: i18n.gettext('Código para escanear'), bullets: [i18n.gettext('Permítele a los clientes pagar escaneando un código.'), i18n.gettext('Muéstralo impreso o digital y cobra con Mercado Pago.')], link: `/developers/${lang}/docs/qr-code/landing`, track: 'qr-code', sites: ['MLA', 'MLB', 'MLU', 'MLC'], label: i18n.gettext('Código QR') },
  ];

  const getLocalizedImage = (images, brandName, langName) => {
    if (brandName === 'yellowblue-light') {
      return images[`re-${langName}`] || images[langName];
    }
    return images[langName];
  };

  const bullets = bulletsAux.filter((m) => m.sites.includes('allSites') || m.sites.includes(siteId));
  const PointImage = getLocalizedImage(Point, brand, lang);
  const PointMobileImage = getLocalizedImage(PointMobile, brand, lang);

  const getImagePoint = () => {
    if (isMobile) {
      const ImageArgMobile = PointMobile[siteId.toLowerCase()];
      return siteId === 'MLA' ? <ImageArgMobile /> : <PointMobileImage />;
    }

    const ImageArg = Point[siteId.toLowerCase()];
    return siteId === 'MLA' ? <ImageArg /> : <PointImage />;
  };

  return (
    <Background
      className={`inperson-content inperson-${brand}`}
      component="section"
      curves={isYellowBlueLightBrand(brand) ? 1 : 4}
      type="middle"
      id="inperson-payments"
     >
      <Title
        className={`inperson-content-title title-${brand}`}
        title={i18n.gettext('Guía para cobro presencial')}
        description={i18n.gettext('Recursos para vender en un local o desde donde quieras.')}
        isHero
      />
      <div className="inperson-content-container">
        {getImagePoint()}
        <div className="inperson-content-text">
          {bullets.map((bullet) => (
            <ComponentText
              pillText={bullet.pillText}
              title={bullet.title}
              bullets={bullet.bullets}
              link={bullet.link}
              track={bullet.track}
              label={bullet.label}
              brand={brand}
          />
          ))}
        </div>
      </div>
    </Background>
  );
};

module.exports = InpersonPayment;
